import { useEffect } from "react";

import useTheme from "./useTheme";

/**
 * Opts a page out of theming: light for as long as it is mounted, whatever the
 * saved preference is, and back to that preference on the way out.
 *
 * For screens that sit outside the signed-in app — the login page above all.
 * They are their own piece of art, styled largely in literal colours rather
 * than tokens, so a dark page only reaches the handful of controls that do read
 * tokens and leaves the rest light. Half a theme looks like a bug, and the
 * whole page would have to be tokenised to fix it properly. Until then it is
 * better off with no theme at all than with part of one.
 *
 * The attribute is not written here: ThemeProvider owns it, and a child's
 * effects run before its parent's, so anything painted from this side would be
 * overwritten by the preference a moment later. Registering instead lets the
 * provider paint light itself, and unregistering restores the preference
 * without this hook having to remember what it was.
 *
 * The inline boot script in index.html skips dark on these paths too, so a cold
 * load doesn't flash the wrong theme before React is up.
 */
const useUnthemedPage = () => {
    const { registerUnthemedPage } = useTheme();

    useEffect(() => registerUnthemedPage(), [registerUnthemedPage]);
};

export default useUnthemedPage;
